<div class="admin-page users-page">
    <div class="admin-toolbar">
        <h3>Usuários</h3>
        <span class="admin-hint">Associados a este produtor</span>
    </div>

    @if (associatedUsers$ | async; as users) { @if (users.length > 0) {
    <div class="table">
        <div class="thead">
            <span>Nome</span>
            <span>E-mail</span>
            <span class="actions-h">Ações</span>
        </div>
        @for (user of users; track user) {
        <div class="row">
            <div class="name">
                <span class="av">{{ userInitials(user) }}</span>
                <b>{{ user.firstName }} {{ user.lastName }}</b>
            </div>
            <div class="mail">{{ user.email || '—' }}</div>
            <div class="actions">
                <button
                    type="button"
                    mat-icon-button
                    color="primary"
                    (click)="openEditUserDialog(user)"
                    aria-label="Editar"
                >
                    <mat-icon>edit</mat-icon>
                </button>
            </div>
        </div>
        }
    </div>
    } @else {
    <p class="empty">Nenhum usuário associado.</p>
    } } @else {
    <div class="loading"><mat-spinner diameter="32"></mat-spinner></div>
    }
</div>
